<app-modal-filler-atom
  (click)="closeModal()"
  [index]="index$ | async"
></app-modal-filler-atom>
<div
  class="fixed right-0 left-0 shadow z-100 overflow-y-auto"
  [ngClass]="
    (settingsSelector.selectDeviceIsMobileScreen | async)
      ? 'bottom-0 max-h-85-screen max-w-screen-sm'
      : 'flex justify-center items-center w-full h-full top-0 left-0'
  "
  [style.z-index]="(index$ | async) + 50"
>
  <div class="p-5 md:p-7 bg-white rounded-t-3xl lg:rounded-3xl">
    <div class="flex justify-between items-center">
      <h2 class="font-accent font-bold text-3xs">
        {{ 'personnal-informations-modal.title' | translate }}
      </h2>
    </div>
    <p class="mt-5 mb-2 text-neutral-600 font-base">
      {{ 'personnal-informations-modal.phone' | translate }}
    </p>
    <div class="text-neutral-800 leading-5 pb-6">
      <app-input-country-phone
        id="phone"
        [phone]="userPhone"
        [selectedIso]="
          (marketplaceCountry$ | async) ? (marketplaceCountry$ | async) : countryIso.France
        "
        [alternativeStyle]="true"
        [listOnTop]="true"
        (updatePhone)="onUpdatePhone($event)"
      ></app-input-country-phone>
    </div>
    <div class="pt-1 flex">
      <div class="mr-2 xm:pr-1 w-full xm:w-1/2">
        <app-button-atom
          size="M"
          [label]="'personnal-informations-modal.cancel' | translate"
          color="primary"
          (click)="closeModal()"
          type="light"
          [full]="true"
        ></app-button-atom>
      </div>
      <div class="xm:pt-0 xm:pl-1 w-full xm:w-1/2">
        <app-button-atom
          size="M"
          [label]="'personnal-informations-modal.add' | translate"
          (click)="updateInformation()"
          type="primary"
          [full]="true"
        ></app-button-atom>
      </div>
    </div>
  </div>
</div>
